module.exports = __webpack_public_path__ + "media/assets/images/flags/ae-1b614532eadec253579fbd6eb79f4ebd.svg";